import { render, staticRenderFns } from "./smarttablequestion.vue?vue&type=template&id=89ac968c&scoped=true"
import script from "./smarttablequestion.vue?vue&type=script&lang=js"
export * from "./smarttablequestion.vue?vue&type=script&lang=js"
import style0 from "./smarttablequestion.vue?vue&type=style&index=0&id=89ac968c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ac968c",
  null
  
)

export default component.exports